import styled from 'styled-components'
import {ReactComponent as InstagramIcon} from './icon_instagram.svg'
import {ReactComponent as FacebookIcon} from './icon_facebook.svg'
import {ReactComponent as TwitterIcon} from './icon_twitter.svg'
import {ReactComponent as HappyIcon} from './happy_face.svg'

export const Container = styled.div`
  color: #000;
  max-width: 28rem;
  margin: 0 auto;
`
export const Happy = styled(HappyIcon)`
  fill: ${(props) => props.bgColor};
`
export const Socials = styled.div`
  display: flex;
  justify-content: center;

  svg {
    margin: 0 1em;
  }
`
export const Instagram = styled(InstagramIcon)`
  fill: ${(props) => props.bgColor};
`
export const Facebook = styled(FacebookIcon)`
  fill: ${(props) => props.bgColor};
`
export const Twitter = styled(TwitterIcon)`
  fill: ${(props) => props.bgColor};
`
export const H4 = styled.h4`
  font-size: 3rem;
  font-weight: 600;
  line-height: 1;
  margin: 0.6em 0 0;
  color: ${(props) => props.bgColor};
`
export const SuccessContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem auto;
  text-align: center;
`
